import { Middleware } from '@reduxjs/toolkit';

// eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-vars
const loggerMiddleware: Middleware = (store) => (next) => (action) => {
  console.log('DEBUG5 Dispatching action:', action, store.getState());
  return next(action);
};

export default loggerMiddleware;
